import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import LoginView from '@/components/help/login-view.vue';
import store from '@/store/index'; // import composition from '@/composition'
// const { wxShare } = composition()

export default {
  setup(__props) {
    // import mock from '@/mock/index'
    store.dispatch('_initApp');
    document.title = '帮办'; // wxShare('求助报料，找记者帮办！', '佛山市新闻传媒中心统一问政报料平台')

    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_KeepAlive, {
          include: ['HelpHomeView', 'HelpPublishView', 'ReputationView']
        }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1024))]),
        _: 1
      }), _createVNode(LoginView)], 64);
    };
  }

};